export default __webpack_public_path__ + "static/media/apple_pay.04030e66.svg";